import React from 'react'
import { useIntl } from 'react-intl'
import { useForm } from 'react-hook-form'
import { Button, Field } from 'msp-components'
import type { FieldsConfiguration } from 'msp-components'

import * as S from './PosStart.styles'

const AgentIdForm = ({
  onSubmit,
  initialValue = ''
}: {
  onSubmit: (data: { agentId: string }) => void
  initialValue?: string
}) => {
  const { formatMessage } = useIntl()
  const { control, handleSubmit } = useForm()

  const fieldConfig: FieldsConfiguration = {
    agentId: {
      id: 'agentId',
      type: 'text',
      name: 'agentId',
      placeholder: '',
      defaultValue: initialValue,
      label: formatMessage({
        defaultMessage: 'Enter agent id',
        id: 'msp.agent_form.agent_id'
      })
    }
  }

  return (
    <div className={S.agentFormWrapper}>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
        <Field
          control={control}
          config={fieldConfig.agentId}
          className='mt-8'
        />
        <Button className={S.agentFormSubmitButton} isSubmit type='primary'>
          {formatMessage({
            defaultMessage: 'ok',
            id: 'msp.agent_form.submit'
          })}
        </Button>
      </form>
    </div>
  )
}
export default AgentIdForm
